import React, { useEffect, useState } from 'react';
import {
    Grid,
    Card,
    CardContent,
    CardMedia,
    Typography,
    CssBaseline,
    Container,
} from '@mui/material';
import BASE_URL from '../config';
const Staff = () => {
    const [staff, setStaff] = useState([]);

    // Fetch staff records from the server
    useEffect(() => {
        const fetchStaff = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/staffs`); // Replace with your API endpoint
                const data = await response.json();
                setStaff(data);
            } catch (error) {
                console.error('Error fetching staff records:', error);
            }
        };

        fetchStaff();
    }, []);

    return (
        <>
            <CssBaseline />
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Typography
                    variant="h4"
                    component="h1"
                    textAlign="center"
                    gutterBottom
                    sx={{ fontWeight: 'bold', color: '#3f51b5' }}
                >
                    Meet Our Team
                </Typography>
                <Grid container spacing={4}>
                    {staff.map((member) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={member.staff_id}>
                            <Card
                                sx={{
                                    maxWidth: 345,
                                    margin: 'auto',
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                    borderRadius: '16px',
                                }}
                            >
                                <CardMedia
                                    component="img"

                                     //width="600"
                                    //height="600"
                                    height="200"
                                    //image={member.photo_url} // Replace with your photo field
                                    image={`${BASE_URL}/${member.photo_url}`}
                                    //src={`https://apiviztech.in:6100/uploads/thumbnails${thumbnail}`}
                                    alt={`${member.name}'s photo`}
                                    sx={{
                                        /* width: '100%', // Automatically adjusts width
                                        height: 'auto', // Maintains aspect ratio */
                                        objectFit: 'contain',
                                        borderTopLeftRadius: '16px',
                                        borderTopRightRadius: '16px',
                                        //width: '100%', // Ensure the image scales responsively
                                        //height: '300px', // Ensure the container has consistent
                                        //backgroundColor: '#f4f4f4', // Optional background to handle empty spaces height
                                    }}
                                />
                                <CardContent sx={{ textAlign: 'center' }}>
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        sx={{ fontWeight: 'bold', color: '#333' }}
                                    >
                                        {member.name}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ margin: '4px 0' }}
                                    >
                                        {member.designation}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {member.specialization}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
};

export default Staff;
